<template>
    <ul ref="container" class="profile-skills" data-testid="profile-skills-list">
        <li v-for="skill in normalizedSkills" :key="skill.key">
            <VJoyTag
                :id="`skill-${slugify(skill.value)}-${id}`"
                class="profile-skills__tag"
                :label="skill.value"
                :value="skill.value"
                :variant="skill.status === 'profile-only' ? 'inactive' : 'secondary'"
                size="xsmall"
            />
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {computed, useId} from 'vue';
    import {VJoyTag} from '@maltjoy/core-vue';
    import {normalizeSkills} from '../../../utils/normalizeSkills';
    import {slugify} from '../internal/slugify';
    import type {SkillWithMatch} from '../types';

    const id = useId();

    const props = withDefaults(
        defineProps<{
            skills: string[] | SkillWithMatch[];
            maxLines?: number;
        }>(),
        {
            maxLines: 2,
        },
    );

    const normalizedSkills = computed(() => normalizeSkills(props.skills));
</script>

<style scoped lang="scss">
    .profile-skills {
        --skill-badge-height: 20px;
        --profile-skills-row-gap: var(--joy-core-spacing-2);
        --profile-card-skills-max-width: 146px;

        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        overflow: hidden;
        gap: var(--profile-skills-row-gap) var(--joy-core-spacing-2);
        max-height: calc(v-bind(maxLines) * var(--skill-badge-height) + (v-bind(maxLines) - 1) * var(--profile-skills-row-gap));

        &__tag {
            overflow: hidden;
            padding-top: 3px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;
            max-width: var(--profile-card-skills-max-width);
            transition: none; // fix stuttering when the ProfileCard is used in primevue/carousel
        }
    }
</style>
